import { useState } from 'react';
import FormSelect from 'components/FormSelect/FormSelect';

interface Props {
  PageData?: any;
  index: number;
  formValues?: any;
  setFormValues?: any;
  isSubmitting?: boolean;
}

const AgeAndGender = ({
  PageData,
  index,
  formValues,
  setFormValues,
  isSubmitting,
}: Props) => {
  let newFormValues = { ...formValues.AboutYouFormModel };

  let handleGenderChange = (i: number, e: string) => {
    newFormValues.AgeAndGender[i]["gender"] = e;
    setFormValues({ ...formValues, AboutYouFormModel: newFormValues });
  };

  let handleAgeChange = (i: number, e: string) => {
    newFormValues.AgeAndGender[i]["age"] = e;
    setFormValues({ ...formValues, AboutYouFormModel: newFormValues });
  };

  return (
    <div className="FormSelect__Row FormSelect__Row--TwoColumns">
      <div>
        <FormSelect
          value={newFormValues.AgeAndGender[index]["gender"]}
          options={[PageData?.GenderOptionFemale, PageData?.GenderOptionMale]}
          onChange={e => handleGenderChange(index, e)}
          indicateError={(isSubmitting && !newFormValues.AgeAndGender[index]["gender"])}
        />
      </div>
      <div>
        <FormSelect
          value={newFormValues.AgeAndGender[index]["age"]}
          options={[PageData?.AgeFirstOptionLabel, PageData?.AgeSecondOptionLabel, PageData?.AgeThirdOptionLabel, PageData?.AgeFourthOptionLabel, PageData?.AgeFifthOptionLabel, PageData?.AgeSixthOptionLabel]}
          onChange={e => handleAgeChange(index, e)}
          indicateError={(isSubmitting && !newFormValues.AgeAndGender[index]["age"])}
        />
      </div>
    </div>
  );
};

export default AgeAndGender;